export type Routes =
  | ScenarioList
  | ScenarioEditor
  | ScenarioHistory
  | StepGroupList
  | StepGroupEditor
  | TestPlanList
  | TestPlan
  | TestPlanScenarioList
  | TestCaseResults
  | UserSettings
  | ProjectSettingsList
  | CustomActionDependents
  | NewCustomActionForm
  | EditCustomActionForm
  | CapabilityForm
  | GotthardKeyNewForm
  | GotthardKeyEditForm
  | AdminCustomActionReader
  | NewAdminSsoConfirmationForm
  | EditAdminSsoConfigurationForm
  | DestroyAdminSsoConfigurationForm
  | NewAdminCustomActionForm
  | EditAdminCustomActionForm
  | AdminScenarioTransfers
  | AdminPartnerList
  | AdminPartnerDetail
  | PartnerScenarioTransfers
  | PartnerOrganizations
  | PartnerProjects
  | TriggerEditor
  | TrialForm
  | TrialFormSettings
  | TrialFormUsage
  | TestPlanResultList
  | Report
  | Project
  | DomSnapshot
  | Graphiql
  | TestPlanCapabilityResult

export interface ScenarioList {
  readonly kind: "ScenarioList"
  readonly projectId: number
}

export function scenarioList({
  projectId,
}: Omit<ScenarioList, "kind">): ScenarioList {
  return {
    kind: "ScenarioList",
    projectId,
  }
}

export interface ScenarioEditor {
  readonly kind: "ScenarioEditor"
  readonly projectId: number
  readonly scenarioId: number
}

export function scenarioEditor({
  projectId,
  scenarioId,
}: Omit<ScenarioEditor, "kind">): ScenarioEditor {
  return {
    kind: "ScenarioEditor",
    projectId,
    scenarioId,
  }
}

export interface ScenarioHistory {
  readonly kind: "ScenarioHistory"
  readonly projectId: number
  readonly scenarioId: number
  readonly historyId: number
}

export function scenarioHistory({
  projectId,
  scenarioId,
  historyId,
}: Omit<ScenarioHistory, "kind">): ScenarioHistory {
  return {
    kind: "ScenarioHistory",
    projectId,
    scenarioId,
    historyId,
  }
}

export interface CompareScenarioHistory {
  readonly kind: "ScenarioHistory"
  readonly projectId: number
  readonly scenarioId: number
  readonly historyId: number
  readonly compareId: number
}

export function compareScenarioHistory({
  projectId,
  scenarioId,
  historyId,
  compareId,
}: Omit<CompareScenarioHistory, "kind">): CompareScenarioHistory {
  return {
    kind: "ScenarioHistory",
    projectId,
    scenarioId,
    historyId,
    compareId,
  }
}

export interface StepGroupList {
  readonly kind: "StepGroupList"
  readonly projectId: number
}

export function stepGroupList({
  projectId,
}: Omit<StepGroupList, "kind">): StepGroupList {
  return {
    kind: "StepGroupList",
    projectId,
  }
}

export interface StepGroupEditor {
  readonly kind: "StepGroupEditor"
  readonly projectId: number
  readonly stepGroupId: number
}

export function stepGroupEditor({
  projectId,
  stepGroupId,
}: Omit<StepGroupEditor, "kind">): StepGroupEditor {
  return {
    kind: "StepGroupEditor",
    projectId,
    stepGroupId,
  }
}

export interface TestPlanList {
  readonly kind: "TestPlanList"
  readonly projectId: number
}

export function testPlanList({
  projectId,
}: Omit<TestPlanList, "kind">): TestPlanList {
  return {
    kind: "TestPlanList",
    projectId,
  }
}

export interface TestPlan {
  readonly kind: "TestPlan"
  readonly projectId: number
  readonly testPlanId: number
}

export function testPlan({
  projectId,
  testPlanId,
}: Omit<TestPlan, "kind">): TestPlan {
  return {
    kind: "TestPlan",
    projectId,
    testPlanId,
  }
}

export interface TestPlanScenarioList {
  readonly kind: "TestPlanScenarioList"
  readonly projectId: number
  readonly testPlanId: number
}

export function testPlanScenarioList({
  projectId,
  testPlanId,
}: Omit<TestPlanScenarioList, "kind">): TestPlanScenarioList {
  return {
    kind: "TestPlanScenarioList",
    projectId,
    testPlanId,
  }
}

export interface TestCaseResults {
  readonly kind: "TestCaseResults"
  readonly projectId: number
  readonly resultId: number
  readonly capabilityId: number
  readonly scenarioId: number
}

export function testCaseResults({
  projectId,
  resultId,
  capabilityId,
  scenarioId,
}: Omit<TestCaseResults, "kind">): TestCaseResults {
  return {
    kind: "TestCaseResults",
    projectId,
    resultId,
    capabilityId,
    scenarioId,
  }
}

export interface UserSettings {
  readonly kind: "UserSettings"
  readonly userId: number
}

export function userSettings({
  userId,
}: Omit<UserSettings, "kind">): UserSettings {
  return {
    kind: "UserSettings",
    userId,
  }
}

export interface ProjectSettingsList {
  readonly kind: "ProjectSettingsList"
  readonly projectId: number
}

export function projectSettingsList({
  projectId,
}: Omit<ProjectSettingsList, "kind">): ProjectSettingsList {
  return {
    kind: "ProjectSettingsList",
    projectId,
  }
}

export interface NewCustomActionForm {
  readonly kind: "NewCustomActionForm"
  readonly projectId: number
}

export function newCustomActionForm({
  projectId,
}: Omit<NewCustomActionForm, "kind">): NewCustomActionForm {
  return {
    kind: "NewCustomActionForm",
    projectId,
  }
}

export interface EditCustomActionForm {
  readonly kind: "EditCustomActionForm"
  readonly projectId: number
}

export function editCustomActionForm({
  projectId,
}: Omit<EditCustomActionForm, "kind">): EditCustomActionForm {
  return {
    kind: "EditCustomActionForm",
    projectId,
  }
}

export interface CustomActionDependents {
  readonly kind: "CustomActionDependents"
  readonly projectId: number
}

export function customActionDependents({
  projectId,
}: Omit<CustomActionDependents, "kind">): CustomActionDependents {
  return {
    kind: "CustomActionDependents",
    projectId,
  }
}

export interface CapabilityForm {
  readonly kind: "CapabilityForm"
  readonly projectId: number
  readonly testPlanId: number
}

export function capabilityForm({
  projectId,
  testPlanId,
}: Omit<CapabilityForm, "kind">): CapabilityForm {
  return {
    kind: "CapabilityForm",
    projectId,
    testPlanId,
  }
}

export interface GotthardKeyNewForm {
  readonly kind: "GotthardKeyNewForm"
  readonly projectId: number
}

export function gotthardKeyNewForm({
  projectId,
}: Omit<GotthardKeyNewForm, "kind">): GotthardKeyNewForm {
  return {
    kind: "GotthardKeyNewForm",
    projectId,
  }
}

export interface GotthardKeyEditForm {
  readonly kind: "GotthardKeyEditForm"
  readonly projectId: number
  readonly gotthardKeyId: number
}

export function gotthardKeyEditForm({
  projectId,
  gotthardKeyId,
}: Omit<GotthardKeyEditForm, "kind">): GotthardKeyEditForm {
  return {
    kind: "GotthardKeyEditForm",
    projectId,
    gotthardKeyId,
  }
}

export interface AdminCustomActionReader {
  readonly kind: "AdminCustomActionReader"
  readonly customActionId: number
}

export function adminCustomActionReader({
  customActionId,
}: Omit<AdminCustomActionReader, "kind">): AdminCustomActionReader {
  return {
    kind: "AdminCustomActionReader",
    customActionId,
  }
}

export interface NewAdminSsoConfirmationForm {
  readonly kind: "NewAdminSsoConfirmationForm"
  readonly organizationId: number
}

export function NewAdminSsoConfirmationForm({
  organizationId,
}: Omit<NewAdminSsoConfirmationForm, "kind">): NewAdminSsoConfirmationForm {
  return {
    kind: "NewAdminSsoConfirmationForm",
    organizationId,
  }
}

export interface EditAdminSsoConfigurationForm {
  readonly kind: "EditAdminSsoConfigurationForm"
  readonly ssoConfigurationId: number
}

export function EditAdminSsoConfigurationForm({
  ssoConfigurationId,
}: Omit<EditAdminSsoConfigurationForm, "kind">): EditAdminSsoConfigurationForm {
  return {
    kind: "EditAdminSsoConfigurationForm",
    ssoConfigurationId,
  }
}

export interface DestroyAdminSsoConfigurationForm {
  readonly kind: "DestroyAdminSsoConfigurationForm"
  readonly ssoConfigurationId: number
}

export function DestroyAdminSsoConfigurationForm({
  ssoConfigurationId,
}: Omit<
  DestroyAdminSsoConfigurationForm,
  "kind"
>): DestroyAdminSsoConfigurationForm {
  return {
    kind: "DestroyAdminSsoConfigurationForm",
    ssoConfigurationId,
  }
}

export interface NewAdminCustomActionForm {
  readonly kind: "NewAdminCustomActionForm"
}

export function newAdminCustomActionForm(): NewAdminCustomActionForm {
  return {
    kind: "NewAdminCustomActionForm",
  }
}

export interface EditAdminCustomActionForm {
  readonly kind: "EditAdminCustomActionForm"
  readonly customActionId: number
}

export function editAdminCustomActionForm({
  customActionId,
}: Omit<EditAdminCustomActionForm, "kind">): EditAdminCustomActionForm {
  return {
    kind: "EditAdminCustomActionForm",
    customActionId,
  }
}

export interface AdminScenarioTransfers {
  readonly kind: "AdminScenarioTransfers"
}

export function adminScenarioTransfers(): AdminScenarioTransfers {
  return {
    kind: "AdminScenarioTransfers",
  }
}

export interface AdminPartnerList {
  readonly kind: "AdminPartnerList"
}

export function adminPartnerList(): AdminPartnerList {
  return {
    kind: "AdminPartnerList",
  }
}

export interface AdminPartnerDetail {
  readonly kind: "AdminPartnerDetail"
}

export function adminPartnerDetail(): AdminPartnerDetail {
  return {
    kind: "AdminPartnerDetail",
  }
}

export interface PartnerScenarioTransfers {
  readonly kind: "PartnerScenarioTransfers"
}

export function partnerScenarioTransfers(): PartnerScenarioTransfers {
  return {
    kind: "PartnerScenarioTransfers",
  }
}

export interface PartnerOrganizations {
  readonly kind: "PartnerOrganizations"
}

export function partnerOrganizations(): PartnerOrganizations {
  return {
    kind: "PartnerOrganizations",
  }
}

export interface PartnerProjects {
  readonly kind: "PartnerProjects"
  readonly organizationId: number
}

export function partnerProjects({
  organizationId,
}: Omit<PartnerProjects, "kind">): PartnerProjects {
  return {
    kind: "PartnerProjects",
    organizationId,
  }
}

export interface TriggerEditor {
  readonly kind: "TriggerEditor"
  readonly projectId: number
  readonly testPlanId: number
}

export function triggerEditor({
  projectId,
  testPlanId,
}: Omit<TriggerEditor, "kind">): TriggerEditor {
  return {
    kind: "TriggerEditor",
    projectId,
    testPlanId,
  }
}

export interface TrialForm {
  readonly kind: "TrialForm"
}

export function trialForm(): TrialForm {
  return {
    kind: "TrialForm",
  }
}

export interface TrialFormSettings {
  readonly kind: "TrialFormSettings"
}

export function trialFormSettings(): TrialFormSettings {
  return {
    kind: "TrialFormSettings",
  }
}

export interface TrialFormUsage {
  readonly kind: "TrialFormUsage"
}

export function trialFormUsage(): TrialFormUsage {
  return {
    kind: "TrialFormUsage",
  }
}

export interface TestPlanResultList {
  readonly kind: "TestPlanResultList"
  readonly projectId: number
}

export function TestPlanResultList({
  projectId,
}: Omit<TestPlanResultList, "kind">): TestPlanResultList {
  return {
    kind: "TestPlanResultList",
    projectId,
  }
}

export interface Report {
  readonly kind: "Report"
  readonly projectId: number
}

export function report({ projectId }: Omit<Report, "kind">): Report {
  return {
    kind: "Report",
    projectId,
  }
}

export interface Project {
  readonly kind: "Project"
  readonly projectId: number
}

export function project({ projectId }: Omit<Project, "kind">): Project {
  return {
    kind: "Project",
    projectId,
  }
}

export interface DomSnapshot {
  readonly kind: "DomSnapshot"
}

export function domSnapshot(): DomSnapshot {
  return {
    kind: "DomSnapshot",
  }
}

export interface Graphiql {
  readonly kind: "Graphiql"
}

export function graphiql(): Graphiql {
  return {
    kind: "Graphiql",
  }
}

export interface TestPlanCapabilityResult {
  readonly kind: "TestPlanCapabilityResult"
  readonly projectId: number
  readonly resultId: number
  readonly capabilityId: number
}

export function testPlanCapabilityResult({
  projectId,
  resultId,
  capabilityId,
}: Omit<TestPlanCapabilityResult, "kind">): TestPlanCapabilityResult {
  return {
    kind: "TestPlanCapabilityResult",
    projectId,
    resultId,
    capabilityId,
  }
}
